import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function DetailRow({ label, value, children }) {
  return (
    <Box display="flex" justifyContent="space-between" gap={1.5}>
      <Typography variant="body2" color="text.secondary" display="block">
        {label}
      </Typography>
      {children || <Typography variant="body2">{value}</Typography>}
    </Box>
  );
}
